export const onboardingApiHandler = {
  getProgress: {
    method: "GET",
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/progress`,
    params: {} as {'status'?: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE'}
  },
  getUserProgress: {
    method: "GET",
    // Same endpoint as getProgress — the backend only registers @Get('progress');
    // the per-user drill-down is the same route with ?userId= as a query param,
    // not a path segment (there is no .../progress/:userId route).
    path: (payload: { orgId: number | string }) => `admin-dashboard/organizations/${payload.orgId}/onboarding/progress`,
    params: {} as { userId: number | string }
  }
};
